import { ExclamationIcon } from '@ankr.com/ui';
import { Link, Typography } from '@mui/material';

import { Placeholder } from 'modules/common/components/Placeholder';
import { TextTooltip } from 'modules/common/components/TextTooltip';
import { useIsFreemiumAllowanceActivating } from 'modules/billing/hooks/useIsFreemiumAllowanceActivating';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { freemiumAllowanceActivatingLabelTranslation } from './translation';
import { useFreemiumAllowanceActivatingLabelStyles } from './useFreemiumAllowanceActivatingLabelStyles';

export interface FreemiumAllowanceActivatingLabelProps {
  isShortened: boolean;
}

const separator = '•';

export const FreemiumAllowanceActivatingLabel = ({
  isShortened,
}: FreemiumAllowanceActivatingLabelProps) => {
  const { classes } = useFreemiumAllowanceActivatingLabelStyles(isShortened);

  const { keys, t } = useTranslation(
    freemiumAllowanceActivatingLabelTranslation,
  );

  const isFreemiumAllowanceActivating = useIsFreemiumAllowanceActivating();

  if (!isFreemiumAllowanceActivating) {
    return null;
  }

  const variant = isShortened ? 'body4' : 'body3';
  const icon = <ExclamationIcon className={classes.icon} size={20} />;

  return (
    <>
      <Placeholder
        hasPlaceholder={isShortened}
        placeholder={
          <TextTooltip disableHoverListener={false} title={t(keys.iconTooltip)}>
            {icon}
          </TextTooltip>
        }
      >
        {icon}
        <TextTooltip disableHoverListener={false} title={t(keys.linkTooltip)}>
          <Link className={classes.link} color="textPrimary" variant="body3">
            {t(keys.syncing)}
          </Link>
        </TextTooltip>
      </Placeholder>
      <Typography color="textSecondary" variant={variant}>
        {separator}
      </Typography>
    </>
  );
};
